import { IMatchRun } from "@nkr/models/matching";
import { Alert, Button, Col, Modal, Row, Table } from "react-bootstrap"

interface IProps {
    show: boolean,
    data: IMatchRun,
    onDelete: () => void
    onCancel: () => void
}

const ConfirmDelete = (props: IProps) => {
    const type = props.data != null ? props.data.matchRunTypeDescription : '';
    const submittedDateTime = props.data != null ? props.data.submittedDateTime : '';
    const status = props.data != null ? props.data.statusDescription : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Confirm Delete</Modal.Header>
            <Modal.Body>
                <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>Are you sure you want to delete the follow match run?</Alert>

                <Row>
                    <Col xs={12} lg={3}>Type:</Col>
                    <Col xs={12} lg={9}>{type}</Col>
                </Row>
                <Row>
                    <Col xs={12} lg={3}>Date Submitted:</Col>
                    <Col xs={12} lg={9}>{submittedDateTime}</Col>
                </Row>

                <Row>
                    <Col xs={12} lg={3}>Status:</Col>
                    <Col xs={12} lg={9}>{status}</Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onDelete}>Delete</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDelete;